"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenManager = void 0;
const event_bus_1 = require("./utils/event-bus");
const field_null_exeption_1 = require("./exceptions/field-null.exeption");
const tokenization_providers_constants_1 = require("./constants/tokenization-providers.constants");
const event_types_constants_1 = require("./constants/event-types.constants");
const tokenization_provider_factory_1 = require("./providers/tokenization-provider.factory");
class TokenManager {
    constructor(tokenManagerConfig) {
        this.tokenManagerConfig = tokenManagerConfig;
        if (![tokenization_providers_constants_1.TokenizationProviders.SPREEDLY.toLowerCase(), tokenization_providers_constants_1.TokenizationProviders.VGS.toLowerCase()]
            .includes(this.tokenManagerConfig.provider.toLowerCase())) {
            this.tokenManagerConfig.provider = tokenization_providers_constants_1.TokenizationProviders.SPREEDLY;
        }
        this.eventBus = event_bus_1.EventBus.getInstance();
    }
    withCardNumber(options) {
        this.cardNumber = {
            elementId: options.elementId,
            name: 'card_number',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withCVV(options) {
        this.cvv = {
            elementId: options.elementId,
            name: 'card_cvv',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withFirstName(options) {
        this.firstName = {
            elementId: options.elementId,
            name: 'first_name',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withLastName(options) {
        this.lastName = {
            elementId: options.elementId,
            name: 'last_name',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    withExpirationDate(options) {
        this.expirationDate = {
            elementId: options.elementId,
            name: 'expiration_date',
            placeholder: options.placeholder || ''
        };
        return this;
    }
    createIsDebitInput(options) {
        this.isDebit = {
            elementId: options.elementId,
            name: 'is_debit',
        };
        this.tokenizationProvider.createIsDebitInput(this.isDebit);
    }
    createDocumentOptionsInputs(documentValueOptions, documentTypeOptions) {
        this.documentValue = {
            elementId: documentValueOptions.elementId,
            name: 'document_value',
            placeholder: documentValueOptions.placeholder
        };
        this.documentType = {
            elementId: documentTypeOptions.elementId,
            name: 'document_type_id',
            options: documentTypeOptions.options
        };
        this.tokenizationProvider.createDocumentOptionsInputs(this.documentValue, this.documentType);
    }
    build() {
        if (!this.cvv) {
            throw new field_null_exeption_1.FieldNullException('CVV');
        }
        if (!this.cardNumber) {
            throw new field_null_exeption_1.FieldNullException('card number');
        }
        if (!this.firstName) {
            throw new field_null_exeption_1.FieldNullException('first name');
        }
        if (!this.lastName) {
            throw new field_null_exeption_1.FieldNullException('last name');
        }
        if (!this.expirationDate) {
            throw new field_null_exeption_1.FieldNullException('expiration date');
        }
        this.tokenizationProvider = tokenization_provider_factory_1.TokenizationProviderFactory.getTokenizationProviderClient(this.tokenManagerConfig.provider, {
            isProduction: this.tokenManagerConfig.isProduction,
            cardNumber: this.cardNumber,
            cvv: this.cvv,
            firstName: this.firstName,
            lastName: this.lastName,
            expirationDate: this.expirationDate
        });
        this.tokenizationProvider
            .init()
            .then(() => this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.READY))
            .catch(() => this.eventBus.dipatchEvent(event_types_constants_1.EventTypes.LOAD_ERROR));
    }
    addEventListener(eventName, cb) {
        this.eventBus.addEventListener(eventName, cb);
    }
    tokenizeCreditCard(options) {
        return this.tokenizationProvider.tokenizeCreditCard(options, this.tokenManagerConfig.email);
    }
    reset() {
        this.tokenizationProvider.reset();
    }
    isValidData() {
        if (this.tokenizationProvider) {
            return this.tokenizationProvider.isValidData();
        }
        return false;
    }
    getBinInfo() {
        return this.tokenizationProvider.getBinInfo(this.tokenManagerConfig.email);
    }
    removeHandlers() {
        this.tokenizationProvider.removeHandlers();
    }
}
exports.TokenManager = TokenManager;
